export const capitalizeFirstLetter = (str: string, isNotMakeLowerCase?: boolean) => {
  if (!str) {
    return '';
  }
  const allParts = str.slice(1);
  return str.charAt(0).toUpperCase() + (isNotMakeLowerCase ? allParts : allParts.toLowerCase());
};

export const capitalizeWords = (str: string): string => {
  return str.replace(/(?:^|[ &])\S/g, match => match.toUpperCase());
};

export const normalizeSearchQuery = (query?: string): string => query?.trim() ?? '';

/**
 * Wraps each digit in a fixed-width `<span>` so a string's on-screen width stays
 * stable as digits change (e.g. a ticking countdown) without relying on
 * `tabular-nums`, which swaps in the font's tnum glyph set and can drift from the
 * design's proportional figures.
 *
 * Returns an HTML string — intended for `innerHTML`/`dangerouslySetInnerHTML`.
 */
export function wrapDigitsWithStableWidth(text: string): string {
  return text.replace(/\d/g, digit => `<span class="inline-block w-[1ch] text-center">${digit}</span>`);
}
